import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Blocks as Desc } from './desk'
import { Blocks as Mob } from './mob'

export const Blocks: React.FC = () => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob /> : <Desc />
}
